import React, { useRef, useEffect } from 'react';
import classnames from 'classnames';
import * as styles from './styles.module.scss';

import Swiper from 'swiper';
import 'swiper/swiper-bundle.css';
import SwiperCore, { Pagination } from 'swiper';

import Card from '../Card';
import SwiperPagin from '@/components/UI/SwiperPagin';

SwiperCore.use([Pagination]);

const MobileList = React.memo(({ list }) => {
  const containerRef = useRef(null);
  const paginRef = useRef(null);

  useEffect(() => {
    const swiper = new Swiper(containerRef.current, {
      slidesPerView: 'auto',
      pagination: {
        el: paginRef.current,
      },
    });

    return () => {
      swiper.destroy(true, true);
    };
  }, []);

  return (
    <div className={styles.swiper}>
      <div ref={containerRef} className={classnames('swiper-container')}>
        <div className="swiper-wrapper">
          {list.map((card, i) => (
            <div key={i} className={classnames('swiper-slide', styles.slide)}>
              <Card card={card} />
            </div>
          ))}
        </div>
      </div>

      <div className={styles.swiper_cntrls}>
        <SwiperPagin ref={paginRef} />
      </div>
    </div>
  );
});

export default MobileList;
